import $ from 'jquery';

/**
 * Handle infinite stock visibility button
 *
 * @type {DynamicInitFunction<HTMLElement>}
 */
export default ($collection) => {

	for (const toggleButton of $collection) {

		const $toggleButton = $(toggleButton);
		const $input = $toggleButton.parent().find('input');
		const $hidden = $toggleButton.parent().next('input');

		$toggleButton.on('click.toggle-stock', () => {
			if (toggleButton.dataset.toggleStock === 'false') {
				toggleButton.dataset.toggleStock = 'true';
				$hidden.prop('disabled', false);
				$toggleButton.parent().parent().addClass('show-infinite-stock');
			}
			else {
				toggleButton.dataset.toggleStock = 'false';
				$hidden.prop('disabled', true);
				$toggleButton.parent().parent().removeClass('show-infinite-stock');
			}
			$input.trigger('change');
		});
	}
};